import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Grid, Paper, Container } from "@mui/material"
import TopLinkCard from "molecules/TopLinkCard"
import ThirdParty from "assets/images/cards/ManageThirdParty.png"
import DisplayAgreement from "assets/images/cards/ConsentList.png"
import NoticeConfigCard from "assets/images/cards/NotificationDeliverySettings.png"
import AccountLinkage from "assets/images/cards/AccountLinkage.png"
import LocationManagement from "assets/images/cards/LocationManagement.png"
import { getLocaleJaOrEnInitialUpper } from "locale.js"
import { ThemeProvider } from "@mui/material/styles"
import { createTheme } from "@mui/material/styles"
import { styled } from "@mui/material/styles"

const SM = 735
const MD = 1095

const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: "#f8f9fa",
  boxShadow: "none",
}))

const StyledContainer = styled(Container)(({ theme }) => ({
  position: "relative",
  [theme.breakpoints.down(SM)]: {
    maxWidth: "375px",
  },
  [theme.breakpoints.up(SM)]: {
    maxWidth: "735px",
  },
  [theme.breakpoints.up(MD)]: {
    maxWidth: "1095px",
  },
  paddingTop: "41px",
  paddingLeft: "15px !important",
  paddingRight: "15px !important",
  paddingBottom: "70px",
}))

const TopContents = () => {
  // md. lg. xlは必要になったら設定すること(オーバーライドすること)
  // createThemeは、v5から非推奨です。
  const customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: SM,
        md: MD,
      },
    },
    spacing: 15,
  })
  const intl = useIntl()
  const displayAgreementDetailCard = {
    detail: intl.formatMessage({
      id: "TopContents.DisplayAgreementDetail",
    }),
    linkText: intl.formatMessage({
      id: "TopContents.DisplayAgreementLinkText",
    }),
    image: DisplayAgreement,
    link: "/displayAgreement",
    isRouter: true,
  }
  const thirdPartyDetailCard = {
    detail: intl.formatMessage({ id: "TopContents.ThirdPartyDetail" }),
    linkText: intl.formatMessage({ id: "TopContents.ThirdPartyLinkText" }),
    image: ThirdParty,
    link: "/thirdParty",
    isRouter: true,
  }
  const locationManagementDetailCard = {
    detail: intl.formatMessage({
      id: "TopContents.LocationManagementDetail",
    }),
    linkText: intl.formatMessage({
      id: "TopContents.LocationManagementLinkText",
    }),
    image: LocationManagement,
    link: "/location",
    isRouter: true,
  }

  const noticeConfigCardDetailCard = {
    detail: intl.formatMessage({
      id: "TopContents.NoticeConfigCardDetail",
    }),
    linkText: intl.formatMessage({
      id: "TopContents.NoticeConfigCardLinkText",
    }),
    image: NoticeConfigCard,
    link: "/noticeConfig",
    isRouter: true,
  }
  const accountLinkageDetailCard = {
    detail: intl.formatMessage({ id: "TopContents.AccountLinkageDetail" }),
    linkText: (
      <FormattedMessage
        id={"TopContents.AccountLinkageLinkText"}
        values={{
          linebreak: <br />,
        }}
      />
    ),
    image: AccountLinkage,
    link: process.env.REACT_APP_ACCOUNT_LINKAGE_URL,
    isRouter: false,
    dataGa: "topToAccountLinkage" + getLocaleJaOrEnInitialUpper(),
  }

  const linkCardInfo = [
    displayAgreementDetailCard,
    thirdPartyDetailCard,
    locationManagementDetailCard,
    noticeConfigCardDetailCard,
    accountLinkageDetailCard,
  ]

  return (
    <ThemeProvider theme={customTheme}>
      <StyledPaper>
        <StyledContainer>
          <Grid container direction="row" spacing={1}>
            {linkCardInfo.map((value, index) => {
              return (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <TopLinkCard {...value} />
                </Grid>
              )
            })}
          </Grid>
        </StyledContainer>
      </StyledPaper>
    </ThemeProvider>
  )
}

export default TopContents
